import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../data/offer';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  href = CHECKOUT_URL,
  variant = 'primary',
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const base = 'cta-breathe group inline-flex items-center justify-center gap-2 rounded-xl text-center font-extrabold tracking-tight transition-[background-color,border-color,color] duration-150 ease-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink';
  const sizes = size === 'lg' ? 'px-6 py-4 text-sm sm:px-8 sm:py-5 sm:text-base' : 'px-5 py-3.5 text-sm';
  const variants = variant === 'primary' ? 'bg-accent text-accentInk hover:bg-[#ffbd53]' : 'border border-line bg-surfaceAlt text-ivory hover:border-accent hover:text-accent';
  return <a href={href} className={`${base} ${sizes} ${variants} ${className}`} data-id="element-292" data-mp="2hfs0fqeeheel">
      <span data-id="element-293" data-mp="2ci9nzq16ch1u">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-soft group-hover:translate-x-1" data-id="element-294" data-mp="2cgyklrbn5bb9" />
    </a>;
}